import React, { PureComponent } from "react";
import WelcomeLayout from "../../layouts/welcome";

class TeamReportsSection5Step1 extends PureComponent {
  get right_content() {
    return (
      <span>
        How productive are your
        <br />
        assets?
      </span>
    );
  }

  render() {
    return (
      <WelcomeLayout
        title="Operational Analysis"
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection5Step1;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-5/step-1.js